<template>
	<div class="dashboard_classification">
		<div class="main_div">
			<div class="tab_content">
				<component :is="activeTab.component" v-bind="activeTab.props" />
			</div>
		</div>
	</div>
</template>

<script>
import ComingSoon from "@/components/layout/ComingSoon.vue";
import ResultadosTab from "@/views/financialReports/tabs/ResultadosTab.vue";
import VentasTab from "@/views/financialReports/tabs/VentasTab.vue";
import CostosTab from "@/views/financialReports/tabs/CostosTab.vue";
import GastosTab from "@/views/financialReports/tabs/GastosTab.vue";
import RentabilidadTab from "@/views/financialReports/tabs/RentabilidadTab.vue";
import ActivosTab from "@/views/financialReports/tabs/ActivosTab.vue";
import NoOperTab from "@/views/financialReports/tabs/NoOperTab.vue";
import KpisTab from "@/views/financialReports/tabs/KpisTab.vue";
import { TAB_IDS } from "@/views/financialReports/config/tabs";

// Registry tab id → { component, props }. Reemplaza la cadena de v-if/v-else-if
// con un look-up declarativo: agregar un tab nuevo requiere una sola entry y
// no toca el template. ComingSoon aparece dos veces con label distinto, por eso
// el shape soporta `props` per-entry (spreaded con v-bind en el template).
const TAB_REGISTRY = Object.freeze({
	[TAB_IDS.RESULTADOS]:   { component: "ResultadosTab",   props: {} },
	[TAB_IDS.VENTAS]:       { component: "VentasTab",       props: {} },
	[TAB_IDS.COSTOS]:       { component: "CostosTab",       props: {} },
	[TAB_IDS.GASTOS]:       { component: "GastosTab",       props: {} },
	[TAB_IDS.RENTABILIDAD]: { component: "RentabilidadTab", props: {} },
	[TAB_IDS.ACTIVOS]:      { component: "ActivosTab",      props: {} },
	[TAB_IDS.NO_OPER]:      { component: "NoOperTab",       props: {} },
	[TAB_IDS.KPIS]:         { component: "KpisTab",         props: {} },
	[TAB_IDS.PROYECCIONES]: { component: "ComingSoon",      props: { label: "Proyecciones" } },
});

export default {
	name: "DashboardReports",
	components: {
		ComingSoon,
		ResultadosTab,
		VentasTab,
		CostosTab,
		GastosTab,
		RentabilidadTab,
		ActivosTab,
		NoOperTab,
		KpisTab,
	},
	computed: {
		// El tab activo se deriva 100% del query param — la URL es la fuente
		// única de verdad. Antes vivía en data() + watcher inmediato; la
		// computed elimina state mutable redundante y es forward-compatible
		// con Composition API (mapea 1:1 a un `computed(() => ...)` en setup).
		// La navegación (escribir $route.query.tab) vive en el Sidebar y en
		// Dashboard.vue:onSectionChange — este view es read-only sobre la URL.
		activeNavTab() {
			const tab = this.$route.query.tab;
			return TAB_REGISTRY[tab] ? tab : TAB_IDS.RESULTADOS;
		},
		activeTab() {
			return TAB_REGISTRY[this.activeNavTab];
		},
	},
};
</script>

<style lang="scss" scoped>
.main_div {
	// El outer main.dashboard reserva var(--app-sidebar-w) para el rail;
	// acá sólo damos respiración de contenido al primer carácter.
	padding-left: clamp(16px, 2vw, 32px);
	padding-right: clamp(10px, 5.5vw, 93px);
	padding-bottom: 30px;
}

.tab_content {
	min-height: 400px;
}
</style>
